import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
	root: {
		position: 'relative',
	},
	loader: {
		position: 'absolute',
	},
});

const SubmitButton = ({children, loading, color, fullWidth, ...props}) => {
	const classes = useStyles();

	return (
		<Button
			className={classNames('button', classes.root)}
			color={color}
			{...props}
			style={{width: fullWidth && '100%'}}
		>
			{children}
			{loading && <CircularProgress size={24} className={classes.loader} color={color} />}
		</Button>
	);
};

SubmitButton.propTypes = {
	children: PropTypes.node,
	loading: PropTypes.bool,
	color: PropTypes.string,
	fullWidth: PropTypes.bool,
};

export default SubmitButton;
